<modal class="h-modal pnp-deposite blocked-user-modal" id="blockedUserModal">
    <div class="h-modal__rightside h-modal__mobile--fixed slideInRight">
      <div class="h-modal__header">
        <div class="h-modal__header--inner flex_spacebetween">
          <h2 class="h-modal--title">
            <!-- Brite -->
            <span>{{'britePlayCashier.britePlayHeadingDeposit' | translate}}</span>
          </h2>
          <div class="h-modal--close" (click)="closeModal()">
            <span class="close-mark" ></span>
          </div>
        </div>
      </div>
      <div class="h-modal__without_footer">
        <div class="h-modal__body">
            <div class="blocked-user-content" style="background:#FFF0F9 url('{{siteUrlPath}}/{{mediaUrlPath}}/common/blockeduser_bg.png') no-repeat">
              <h5>
                {{ 'blockedUser.heading' | translate}}
              </h5>
              <p>
                {{'blockedUser.description' | translate}}
              </p>
              <button class="btn btn-move-site" (click)="navigateToSite()">
                {{'blockedUser.buttonName' | translate}}
              </button>
              <h6>
                {{'blockedUser.aboutSite' | translate}}
              </h6>
              <div class="info-boxes">
                <div class="info-box">
                  <div class="info-img">
                    <img src="{{siteUrlPath}}/{{mediaUrlPath}}/common/info-img1.png" alt="">
                  </div>     
                               
                  <p>
                   {{'blockedUser.withdrawlDesription' | translate}}
                  </p>
                </div>
                <div class="info-box">
                  <div class="info-img">
                    <img src="{{siteUrlPath}}/{{mediaUrlPath}}/common/info-img2.png" alt="">
                  </div>
                  <p>
                    {{'blockedUser.favoriteDescription' | translate}}
                  </p>
                </div>
                <div class="info-box">
                  <div class="info-img">
                    <img src="{{siteUrlPath}}/{{mediaUrlPath}}/common/info-img3.png" alt="">
                  </div>
                  <p>
                    {{'blockedUser.benifitsDescription' | translate}}
                  </p>
                </div>
              </div>
              <div class="blocked-logo-div text-center">
                <img src="{{siteUrlPath}}/{{mediaUrlPath}}/common/lysti-logo.png" alt="Lysti-Logo">
              </div>
            </div>
        </div>
      </div>     
    </div>
  </modal>